<template>
  <v-container 
    v-if="!$apollo.loading"
    fill-height
    container--fluid
    grid-list-xl
  >
    <v-layout
      wrap
    >
      <v-flex
        sm12
        xs12 
        md4
      >
        <v-card class="bot-card">
          <v-flex
            class="cover"
            :style="{ backgroundColor: userBot.bot.bgcolor}"
            align-self-start
            xs12
          >
            <v-avatar 
              v-if="userBot.bot.logo !== null"
              :tile="false"
              class="avatar"
              :size="110"
            >
              <v-img
                :src=" userBot.bot.logo"
                :lazy-src="userBot.bot.logo"
                max-height="110"
                contain
              /> 
            </v-avatar>
            <v-avatar
              v-else
              class="avatar"
              style="pointer: cursor;"
              :tile="false"
              :size="110"
              color="#eceff1"
            >
              <strong
                class="avatar-invert"
                style="font-size:30px;"
              > 
                {{ userBot.bot.name | uppercase | substring(0,2) }}
              </strong>
            </v-avatar>
          </v-flex>
          
          <v-flex
            class="description"
            align-self-center
            xs12
          >
            <h4>{{ userBot.bot.name }}</h4>
            <h5>
              <b>{{ userBot.account_name }}</b><br>
              <!-- {{ userBot.created_at | moment("from", "now") }} {{$t('globals.active')}}      -->
              <small
                v-if="userBot.trial_till !== null"
              >
                <b>{{ $t('bots.trialPeriod') }} {{ userBot.trial_till | moment("L") }}</b>   
              </small>
              <small v-else-if="userBot.activated_till !== null">
                <b>{{ $t('bots.activeTill') }} {{ userBot.activated_till | moment("L") }}</b>  
              </small>
            </h5>
          </v-flex> 
          <div
            style="padding:0; position:absolute; bottom:0;width:100%; display:flex;"
          >
            <v-flex xs12>
              <v-btn
                class="bordered round back"
                icon
                text
                small
                @click="$router.go(-1)"
              >
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
            </v-flex>
          </div>
        </v-card>
      </v-flex>
      <v-flex
        md8
      >
        <v-card
          min-height="300"
        >
          <v-flex
            xs12
            md12
          >
            <v-layout
              wrap  
            >
              <v-flex
                md2
                sm12
                xs12
                align-self-center
                class="command-line"
              >
                <span v-if="botStatus =='running'">{{ $t('bots.botRunningStatus') }}</span>
                <span v-else>{{ $t('bots.botStoppedStatus') }}</span>
                <v-icon 
                  :class="botStatus =='running' ? 'blink green-status': 'red-status'"
                >
                  mdi-circle
                </v-icon>
              </v-flex>
              <v-flex
                v-if="userBot.manager == null || userBot.manager.connection_status != 'connected' || $route.path == `/traderbots/aumbot/${userBot.id}`"
                md10
                sm12
                xs12
                text-right
              > 
                <v-btn
                  v-for="(b,i) in buttons"
                  :key="i"
                  style="margin-right:5px;"
                  outlined
                  text
                  small
                  :disabled="loading || b.disabled == botStatus"
                  :loading="loading && buttonClicked == b.id"
                  @click="command(b.id)"
                >
                  {{ b.text }}
                </v-btn>
                <v-menu
                  offset-y
                  left
                  bottom
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      outlined 
                      small
                      text
                      :disabled="loading || botStatus == 'stopped'"
                      v-on="on"
                    >
                      ...
                    </v-btn>
                  </template>
                  <v-sheet 
                    v-if="botCommands != null"
                    dense
                  >
                    <v-list-item
                      v-for="(bCommand,i) in Object.keys(botCommands)"
                      :key="i"
                      @click="executeBotCommand(bCommand)"
                    >
                      <v-list-item-title>{{ botCommands[bCommand].label[$i18n.locale] }}</v-list-item-title>
                    </v-list-item>
                  </v-sheet>
                </v-menu>
              </v-flex>
              <v-flex
                v-else
                text-right
              >
                <small>
                  {{ $t('bots.aumBy') }} <b>{{ userBot.manager.name }}</b>
                  {{ $t('bots.since') }} {{ userBot.manager.request_sent | moment('L') }}
                </small>
              </v-flex>
            </v-layout>
            
            <v-divider wrap />
            <v-progress-linear 
              :active="loading"
              :indeterminate="loading"
              height="1"
              class="absolute bottom"
              color="deep-purple accent-4"
            />
            <v-layout
              v-if="botStatus == 'running' && botInfo != null"
              wrap
              data
              class="overview-card"
            >
              <v-flex
                v-for="(info,i) in Object.keys(botInfo)"
                :key="i"
                md4 
                xs6
                mrg
              > 
                <span>{{ botInfo[info].label[$i18n.locale] }}</span>
                <p v-if="botInfo[info].value == true">
                  {{ $t('bots.yes') }}
                </p>
                <p v-else-if="botInfo[info].value == false">
                  {{ $t('bots.no') }}
                </p>
                <p v-else>
                  {{ botInfo[info].value }}
                </p>
              </v-flex>
            </v-layout>
            <v-layout 
              v-else-if="loading == false"
              class="not-found"
              justify-center
              style="height:250px;"
            >
              <v-flex
                align-self-center
              >
                <v-icon>mdi-ghost</v-icon>
                <p>{{ $t('bots.botStopped') }}</p>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            v-if="botStatus =='running'"
            xs12
            style="padding-bottom:5px;"
          >
            <v-layout justify-end>
              <small class="small">
                {{ $t('bots.dataUpdated') }}
              </small>
            </v-layout>  
          </v-flex>
        </v-card>
      </v-flex>

      <v-flex
        md12
      >
        <v-card style="padding:0;">
          <v-tabs
            v-model="tab"
          >
            <v-tab
              v-for="n in tabs"
              :key="n.id"
              :href="`#${n.id}`"
            >
              {{ n.text }}
            </v-tab>
          </v-tabs>
          <v-tabs-items 
            v-model="tab"
          >
            <v-tab-item
              :transition="false" 
              :reverse-transition="false"
              value="positions"
            >
              <v-flex
                v-if="botPositions != null"
              >
                <v-simple-table
                  dense
                >
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th
                          v-for="(ph,i) in positionsHeaders"
                          :key="i"
                          class="text-left"
                        >
                          <span>{{ ph }}</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr 
                        v-for="(pTr,i) in botPositions" 
                        :key="i"
                      >
                        <td
                          v-for="(pTd,o) in Object.keys(pTr)" 
                          :key="o"
                        >
                          <b>{{ pTr[pTd].value }}</b>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-flex>
              <v-flex
                v-else
                class="not-found"
                justify-center
              >
                <v-icon>mdi-ghost</v-icon>
                <p>{{ $t('bots.noOpenPositions') }}</p>
              </v-flex>
            </v-tab-item> 


            <v-tab-item
              :transition="false" 
              :reverse-transition="false"
              value="income"
            >
              <v-flex
                v-if="botIncome != null"
              >
                <v-simple-table
                  dense
                >
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th
                          v-for="(ph,i) in incomeHeaders"
                          :key="i"
                          class="text-left"
                        >
                          <span>{{ ph }}</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr 
                        v-for="(pTr,i) in botIncome" 
                        :key="i"
                      >
                        <td
                          v-for="(pTd,o) in Object.keys(pTr)" 
                          :key="o"
                        >
                          <b v-if="pTd == 'time'">{{ pTr[pTd].value | moment('L HH:mm:ss') }}</b> 
                          <b v-else>{{ pTr[pTd].value }}</b>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-flex>
              <v-flex
                v-else
                class="not-found"
                justify-center
              >
                <v-icon>mdi-ghost</v-icon>
                <p>{{ $t('bots.noIncome') }}</p>
              </v-flex>
            </v-tab-item> 
          </v-tabs-items> 
        </v-card>   
      </v-flex>
    </v-layout>
    <v-dialog
      v-if="uninstallDialog"
      v-model="uninstallDialog"
      width="400"
      persistent
    >
      <v-card>
        <v-card-title
          class="header info"
          primary-title
        >
          <b>{{ $t('bots.uninstallSureTitle') }}</b>
        </v-card-title>
        <v-card-text>
          <b>{{ $t('bots.uninstallSureText') }}</b>  
        </v-card-text>
        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            :disabled="loading"
            @click="uninstallDialog = false"
          >
            {{ $t('globals.cancelButton') }}
          </v-btn>
          <v-btn
            color="primary"
            :disabled="loading"
            :loading="loading"
            @click="command('uninstall')"
          >
            {{ $t('bots.uninstallButton') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

const USER_BOT_QUERY = require('@/graphql/queries/UserBot.gql');
const MANAGE_USERBOT_MUTATION = require('@/graphql/mutations/ManageUserBot.gql');
import axios from 'axios';
import store from "@/store";

export default {
  name: 'UserBotView',
  data() {
    return {
      tab: null,
      tabs: [{id: "positions", text: this.$t('bots.openPositions')},
            {id: "income", text: this.$t('bots.incomeTab')}
          ],
      loading: false,
      botInfo: null,
      botCommands: null,
      botPositions: null,
      botIncome: null,
      buttonClicked: null,
      botStatus: 'stopped',
      infoInterval: null,
      positionInterval: null,
      incomeInterval: null,
      positionsHeaders: [],
      incomeHeaders: [],
      bot_api_url: null,
      api_total_tries: 3,
      api_tries: 0,
      uninstallDialog: false,
      botHeaders: {
        headers: {
          Authorization: 'Bearer '
        }
      },
      buttons: [
        {id: "start", text: this.$t('bots.startButton'), disabled: 'running'},
        {id: "stop", text: this.$t('bots.stopButton'), disabled: 'stopped'},
        {id: "change", text: this.$t('bots.changeButton'), disabled: 'running'},
        {id: "uninstallConfirm", text: this.$t('bots.uninstallButton'), disabled: 'running'}
      ]
    }
  },
  mounted() {
    this.tab = "positions"
    this.botStatus = "stopped"
  },
  beforeDestroy() {
    this.stopBotApi()
  },
  methods: {
    startBotApi() {
      this.loadCommands()
      setTimeout(()=>{
         this.loadCommands()
      }, 10*1000)
      this.loadInfo()
      this.infoInterval = setInterval(()=>{
        this.loadInfo()
      }, 5*1000)
      this.loadPositions()
      this.positionInterval = setInterval(()=>{
        this.loadPositions()
      }, 5*1000)
      this.loadIncome()
      this.incomeInterval = setInterval(()=>{
        this.loadIncome()
      }, 120*1000)
    },
    stopBotApi() {
      clearInterval(this.infoInterval)
      clearInterval(this.positionInterval)
      clearInterval(this.incomeInterval)
      this.botStatus = 'stopped'
      this.botInfo = null
      this.botPositions = null
    },
    command(command) {
      this.buttonClicked = command
      if(command == 'uninstallConfirm') {
        this.uninstallDialog = true
        return
      }
      if(command == 'change') {
        this.$router.push({ path: '/mybots/update/' + this.userBot.bot.id, query: { ubid: this.$route.params.id }})
        return
      }
      this.loading = true;  
      this.$apollo.mutate({
          mutation: MANAGE_USERBOT_MUTATION,
          variables: {
              command: command,
              user_bot_id: this.$route.params.id,
          }       
      }).then(data => {
        switch(this.buttonClicked) {
          case 'start':
            this.startBotApi()
            break;
          case 'stop':
            this.stopBotApi()
            this.loading = false
            break;
          case 'uninstall':
            this.$router.push('/traderbots/mybots')
            break;  
        }
      }).catch(error => {
          this.errorHandler(error)
          this.loading = false 
      })
    },
    executeBotCommand(command) {
      axios({
        method: this.botCommands[command].method,
        url: this.bot_api_url + this.botCommands[command].route_path,
        headers: {Authorization: 'Bearer ' + this.userBot.access_token}
      })
      .then(response => {
        store.commit('app/setNotifier', response.data.message)
      })
    },
    loadInfo() {
      axios
      .get((this.bot_api_url + '/info'), this.botHeaders)
      .then(response => {
        this.botStatus = 'running'
        this.botInfo = response.data
      })
      .catch(error => {
        this.api_tries += 1
        if (this.api_tries == this.api_total_tries) {
          this.stopBotApi()
          this.api_tries = 0
        }
      })
      .finally(()=>{ 
        if (this.buttonClicked == 'start' && this.botInfo != null)
          this.loading = false
      })
    },
    loadCommands() {
      axios
      .get((this.bot_api_url + '/commands'), this.botHeaders )
      .then(response => {
        this.botCommands = response.data
      })
    },
    loadPositions() {
      axios
      .get((this.bot_api_url + '/positions'), this.botHeaders)
      .then(response => {
        if (this.positionsHeaders.length == 0) {
          let headersKeys = Object.keys(response.data.positions[0])
          headersKeys.forEach(item => {
            this.positionsHeaders.push(response.data.positions[0][item].label[this.$i18n.locale])
          })
        }
        this.botPositions = response.data.positions
      })
      .catch(error => {
        this.botPositions = null
      })
    },
    loadIncome() {
      axios
      .get((this.bot_api_url + '/income'), this.botHeaders)
      .then(response => {
        if (this.incomeHeaders.length == 0) {
          let headersKeys = Object.keys(response.data.positions[0])
          headersKeys.forEach(item => {
            this.incomeHeaders.push(response.data.positions[0][item].label[this.$i18n.locale])
          })
        }
        this.botIncome = response.data.positions
      })
      .catch(error => {
        this.botIncome = null
      })
    }
  },
  apollo: {
    userBot: {
      query: USER_BOT_QUERY,
      variables() {
        return {
           id: this.$route.params.id
        }
      },
      result(data) {
        if (data.loading == false) {
          this.bot_api_url = this.userBot.bot_api_url.replace("{bot_id}", this.userBot.id)
          this.botHeaders.headers.Authorization += this.userBot.access_token
          this.startBotApi()
        }
      }
    }
  }
}
</script>



<style lang="scss" >
  @mixin label-span {
    span {
      font-size: 12px;
      font-weight: 600;
      color: #7f97ab;
      text-transform: uppercase;
    }
  }
  .bot-card {
    padding: 0;
    height: 100%;
    .cover {
      height: 100px;
        background-color: #0a61f0;
        .avatar {
          position: absolute;
          left: 50%;
          top: 40px;
          transform: translate(-50%, 0);
          overflow: hidden;
          z-index: 1;
        }
    }
    .description {
      margin-top:50px;
      h4, h5 {
        line-height: 24px!important;
      }
      
      h4 {
        text-align: center;
        font-weight: 700!important;
        margin:0!important;
      }
      h5 {
        margin: 10px 0 0!important;
        text-align: center;
        font-weight: 400!important;
        font-size: 15px!important;
        color: #7f97ab;
        display: block;
      }
      p {
        text-align: center;
        font-weight: 400;
        font-size: 12px;
      }
    }
    .back {
      width: 20px;
      height: 20px;
      .v-icon {
        margin-top:-2.3px;
        font-size: 0.85rem;
      }
    }
  }
  .command-line {
    @include label-span;
    .v-icon {
      font-size:16px!important;
      margin-left: 5px;
      &.green-status {
         color: #75b211!important;     
      }
      &.red-status {
        color: #d94040!important;  
      }
    }
  }
  .overview-card {
    padding: 10px;
    .mrg {
      p {
        margin-bottom: 5px;
      }
    }
    @include label-span;
    p {
      font-size: 16px;
      font-weight: 700;
    }
  }
  .details-card {
    .data {
      padding: 10px;
      @include label-span;
      p {
        font-size: 15px;
        font-weight: 400;
      }
    } 
  }
  .blink {
    animation: blink-animation 5s steps(5, start) infinite;
    -webkit-animation: blink-animation 5s steps(5, start) infinite;
  }
  .small {
    color: #7f97ab;
  }
  @keyframes blink-animation {
    to {
      visibility: hidden;
    }
  }
  @-webkit-keyframes blink-animation {
    to {
      visibility: hidden;
    }
  }
</style>
